import { ArrowRightOnRectangleIcon, ArrowRightStartOnRectangleIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgentsTwilioNumbers } from "../../models/User";
import { AppDispatch } from "../../state/store";
import { FormSearchableSelect } from "../form/FormSearchableSelect";
import { LoadingMask } from "../LoadingMask";
import { Modal } from "../Modal";
import { Toast } from "../Toast";
import { startTranferConference } from "../../state/twilio/actions";
import { TwilioState } from "../../state/twilio/slice";
import { ReactiveFormPhoneInput } from "../form/ReactiveFormPhoneInput";
import { useForm } from "react-hook-form";
import { isValidPhoneNumber } from "../../utils/functions";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  callSid: string;
}

export const TransferCallModal = (props: Props) => {
  const [selectedAgentOnModal, setSelectedAgentOnModal] = useState<string>();
  const [showError, setShowError] = useState(false);
  const [finalNumber, setFinalNumber] = useState<string | null>();
  const [modalTItle, setModalTitle] = useState<string>(t("TRANSFER_CALL"));

  const users = useSelector((state: any) => state.users);
  const twilio:TwilioState = useSelector((state: { twilio: TwilioState }) => state.twilio);
  const dispatch = useDispatch<AppDispatch>();

  const methods = useForm<{
    phone: string;
  }>();
  const { control, watch, setValue } = methods;
  const otherNumberValue = watch("phone");

  useEffect(() => {
    if (showError) {
      Toast(
        t(twilio.error?.reason ?? "TRANSFER_CALL_ERROR"),
        t(twilio.error?.cause_info ?? "")
      );
      setShowError(false);
    }
  }, [showError, twilio.error]);

  // useEffect(() => {
  //   if (twilio.transferConferenceId) {
  //     const params = { To: finalNumber! };
  //     twilio.device?.connect({params: params}).
  //     then((outgoingCall: any) => {
  //         notifyCallCreated(outgoingCall, 'PhoneBurner - callNext');
  //     }).catch((error: any) => {
  //         console.error('Failed to create outgoing call:', error);
  //     });
  //     props.onClose();
  //   }
  // }, [twilio.transferConferenceId]);

  useEffect(() => {
    if (selectedAgentOnModal && selectedAgentOnModal !== "") {
      setValue("phone", "");

      const number = getAgents.find(
        (x: { value: string }) => selectedAgentOnModal === x.value
      )?.number;

      if (number && isValidPhoneNumber(number)) {
        setFinalNumber(number);
      } else {
        setFinalNumber(null);
      }
    }
  }, [selectedAgentOnModal]);

  useEffect(() => {
    if (otherNumberValue && otherNumberValue !== "" && otherNumberValue !== "+1") {
      setSelectedAgentOnModal("");
      if (isValidPhoneNumber(otherNumberValue)) {
        setFinalNumber(otherNumberValue);
      } else {
        setFinalNumber(null);
      }
    }
  }, [otherNumberValue]);

  useEffect(() => {
    if (finalNumber) {
      setModalTitle(t("TRANSFER_CALL") + ` to ${finalNumber}`);
    } else {
      setModalTitle(t("TRANSFER_CALL"));
    }
  }, [finalNumber])

  const getAgents = useMemo(() => {
    return users.agentsTwilioNumbers
      ?.filter((x: AgentsTwilioNumbers) => x.agent_id !== users.currentUser?.id)
      .map((user: AgentsTwilioNumbers) => {
        return {
          label: `${user.first_name} ${user.last_name} ${user.twilio_phone}`,
          number: user.twilio_phone,
          value: `${user.first_name} ${user.last_name} ${user.twilio_phone}`,
        };
      });
  }, [users]);

  const handleSubmit = () => {
    dispatch(startTranferConference({ call_sid: props.callSid, transferTo: finalNumber! })).then((e) => {
      if (e.type === "calls/startClientConference/rejected") {
        setShowError(true);
      }
    });
  };

  return (
    <>
      {props.isOpen && (
        <Modal
          isOpen={props.isOpen}
          onClose={props.onClose}
          label={modalTItle}
          saveButton={{
            label: t("TRANSFER"),
            icon: <ArrowRightStartOnRectangleIcon />,
            disabled: !finalNumber,
            onClick: handleSubmit,
          }}
        >
          {(users.isLoading || twilio.isLoading) && <LoadingMask />}
          <div className="w-full mb-4">
            {t("SELECT_AGENT_TO_TRANSFER_CALL")}
          </div>
          <FormSearchableSelect
            className="md:w-1/2"
            value={selectedAgentOnModal ?? ""}
            name="agent_number"
            label={t("AGENTS")}
            options={getAgents}
            onChange={(val) => setSelectedAgentOnModal(val)}
          />
          <div className="md:w-1/2 text-gray-700 text-sm mb-2 text-center">
            {t("OR")}
          </div>
          <ReactiveFormPhoneInput
            className="md:w-1/2"
            control={control}
            name="phone"
            label={t("PHONE")}
          />
        </Modal>
      )}
    </>
  );
};
